module.exports = __webpack_public_path__ + "img/examen-1.5f917146.svg";